import { render } from "./RelatorioAtendTempo.vue?vue&type=template&id=f79755ca"
import script from "./RelatorioAtendTempo.vue?vue&type=script&lang=js"
export * from "./RelatorioAtendTempo.vue?vue&type=script&lang=js"

import exportComponent from "D:\\FOP\\AGAPE\\AGAPE_HOSPITALAR\\ReguaHospitalar\\frontpainel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__